import '../sass/app.scss';

import 'dom4';
import domready from 'domready';
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import SwupDebugPlugin from '@swup/debug-plugin';
import SwupJsPlugin from '@swup/js-plugin';
import SwupHeadPlugin from '@swup/head-plugin';
import Cursor from './components/custom-cursor';
import GlobalHeader from './components/global-header';
import ShapeAnimation from './components/shape-animation';
// import Accordions from './components/accordions';
import Slider from './components/slider';
gsap.registerPlugin(ScrollToPlugin)

const touchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
const globalHeader = document.querySelector('[data-component="global-header"]')


domready(() => {

  function init() {
    const appHeight = () => {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }
    window.addEventListener('resize', appHeight)
    appHeight()

    if (touchDevice) {
      document.body.classList.add('touch')
    }

    // Scroll window to top on every page load
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'auto'
    })

    document.queryAll('[data-component="global-header"]').forEach(element => {
      new GlobalHeader({
        element
      })
    })

    document.queryAll('[data-component="cursor"]').forEach(element => {
      new Cursor({
        element
      })
    })

    document.queryAll('[data-component="shape-animation"]').forEach(element => {
      new ShapeAnimation({
        element
      })
    })

    document.queryAll('[data-component="slider"]').forEach(element => {
      new Slider({
        element
      })
    })

    // document.addEventListener('swup:pageLoaded', (event) => {
    //   var cList = document.body.classList
    //   if (
    //     cList.contains('single-client_industries') ||
    //     cList.contains('single-legal_services') ||
    //     cList.contains('post-type-archive-client_industries') ||
    //     cList.contains('post-type-archive-legal_services')) {
    //     gsap.to(window, {duration: 1, scrollTo: {y: ".open", offsetY: 146 }});
    //   }
    // })

  }

  // swupOptions
  const swupOptions = {
    plugins: [
      new SwupBodyClassPlugin(),
      // new SwupGaPlugin(),
      new SwupDebugPlugin(),
      new SwupJsPlugin()
    ],
  }

  // Initialise swup
  const swup = new Swup(swupOptions)

  // Initialise global init
  init()

  // Re-initialise JS on page load
  swup.on('contentReplaced', init)

});
